import { Flex } from "@acko-tech/building-blocks.ui.common";
import {
    DropdownContainer,
    IDVHeading,
    IDVHeadingWrapper,
    IDVSection,
    IDVSectionHeading,
    Price,
    SectionHeader
} from "./styles";
import ArrowUp from "@public/images/arrow-up.svg";
import ArrowDown from "@public/images/arrow-down.svg";
import { EXPANDABLES } from "@widgets/coveragePricingBreakup";
import { getWidgetSpecificProps } from "@utils/index";
import { connect } from "react-redux";
import ImageContainer from "@components/imageContainer";

const mapStateToProps = function (state: any, ownProps: any) {
    return getWidgetSpecificProps(
        state.configuration?.normalisedConfig,
        ownProps.id
    );
};

const ModifyIDV = (props) => {
    const {
        idvValue,
        idvText,
        modifityText,
        actions,
        is_visible,
        expanded,
        setExpanded,
        idvFullForm,
        arrowUpSrc,
        arrowDownSrc,
        idvDescription,
        isTpPlan
    } = props;
    const { on_click } = actions || {};
    const handleModifyIdv = () => {
        if (on_click?.[0] && typeof on_click[0].funCall === "function") {
            on_click?.forEach((eachFunc: any) => {
                eachFunc.funCall(eachFunc.args);
            });
        }
    };

    if (!is_visible || isTpPlan) {
        return null;
    }
    return (
        <>
            <IDVSection>
                <IDVHeadingWrapper>
                    <IDVHeading>{idvText}</IDVHeading>
                    <IDVHeading
                        style={{ textDecorationLine: "underline", fontWeight: 500 }}
                        onClick={handleModifyIdv}
                    >
                        {modifityText}
                    </IDVHeading>
                </IDVHeadingWrapper>
                <SectionHeader
                    onClick={() =>
                        setExpanded((prev) =>
                            prev === EXPANDABLES.IDV ? false : EXPANDABLES.IDV
                        )
                    }
                >
                    <Flex width="auto">
                        <IDVSectionHeading style={{ color: "#040222" }}>{idvFullForm}</IDVSectionHeading>
                        <div
                            style={{
                                width: "100%",
                                height: "100%",
                                maxWidth: "20px",
                                maxHeight: "20px",
                                marginLeft: "4px"
                            }}
                        >
                            {expanded === EXPANDABLES.IDV ? (
                                <ImageContainer imgSrc={arrowUpSrc} width={20} height={20} />
                            ) : (
                                <ImageContainer imgSrc={arrowDownSrc} width={20} height={20} />
                            )}
                        </div>
                    </Flex>

                    <Price>₹{idvValue}</Price>
                </SectionHeader>
            </IDVSection>

            <DropdownContainer expanded={expanded === EXPANDABLES.IDV}>
                <p
                    style={{
                        fontSize: "12px",
                        color: "#5B5675",
                        fontWeight: 400,
                        lineHeight: "18px",
                        marginTop: "0px",
                        marginBottom: "8px"
                    }}
                >
                    {idvDescription}
                </p>
            </DropdownContainer>
        </>
    );
};

export default connect(mapStateToProps)(ModifyIDV);
